__webpack_require__.p = "/NewsDaily/";